// @flow

import * as React from 'react';

import classify from 'src/utils/classify';

import css from './one-line.css';
import borderlessCss from './borderless.css';


export type OneLineInputProps = {
  ...UnstyledOneLineInputProps,
  classNames?: void,
};

export function OneLineTextInput(props: OneLineInputProps): React.Node {
  return <UnstyledOneLineInput {...props} classNames={css} />;
}
export default OneLineTextInput;

export function BorderlessTextInput(props: OneLineInputProps): React.Node {
  return <UnstyledOneLineInput {...props} classNames={borderlessCss} />;
}

export type UnstyledOneLineInputProps = {
  classNames: $ReadOnly<{
    input: string,
    withPrefix: string,
    withError: string,
    small?: string,
    medium?: string,
    ...
  }>,
  className?: string,
  autoFocus?: boolean,
  prefix?: React.Node,
  onChange?: (SyntheticInputEvent<HTMLInputElement>) => mixed,
  onBlur?: (SyntheticEvent<HTMLInputElement>) => mixed,
  onKeyDown?: (SyntheticKeyboardEvent<HTMLInputElement>) => mixed,
  value?: string,
  defaultValue?: string,
  placeholder?: ?string,
  maxLength?: number,
  error?: ?string,
  type?: 'text' | 'email' | 'date' | 'time' | 'number',
  size?: 'medium' | 'small',
  disabled?: mixed,
  min?: number,
  max?: number,
};

export function UnstyledOneLineInput({
  type = 'text',
  classNames,
  className,
  autoFocus,
  prefix,
  error,
  size = 'medium',
  ...props
}: UnstyledOneLineInputProps): React.Element<'div'> {
  const ref = React.useRef();
  React.useEffect(() => {
    if (autoFocus) {
      ref.current?.focus();
    }
  }, [autoFocus]);

  return (
    <div
      className={classify(
        classNames.input,
        className,
        prefix ? classNames.withPrefix : null,
        error && classNames.withError,
        classNames[size],
      )}
      onClick={() => {
        ref.current?.focus();
      }}
    >
      {prefix}
      <input type={type} ref={ref} autoComplete="new-password" {...props} />
    </div>
  );
}

export function OneLineErrorInput({
  error,
  ...props
}: OneLineInputProps): React.Element<'div'> {
  return (
    <div className={css.container}>
      <OneLineTextInput {...props} error={error} />
      <div className={css.errorMessage}>{error}</div>
    </div>
  );
}
